module.exports = __webpack_public_path__ + "img/settings.d1cdf4af.svg";